














































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import BillApi from '@/api/bill'
import { TOKEN, SO_FAR } from '@/store/mutation-types'
import PageLayout from '@/components/page/PageLayout.vue'
import { uuid, dateFormat, throttle, download } from '@/utils/util'
import moment from 'moment'
import EvaluateApi from '@/api/evaluate'
import Task from '@/web-task'
import { triggerWindowResizeEvent } from '@/utils/util'
import cloneDeep from 'lodash/cloneDeep'
import { initOrderDetail } from '@/web-task/utils/order'
import { wsURL } from '@/api/url'
import setting from '@/core/setting'
import InvestigateApi from '@/api/investigate'
import Info from '@/components/task/Info.vue'
import InfoRow from '@/views/AiiTasks/InfoRow.vue'
import { formatTime, formatDate, format } from '@/web-task/filter'
import { zeroUnit } from '@/web-task/utils'
import riskSection from './riskSection.vue'
import RiskApi from '@/api/risk'

Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteUpdate',
	'beforeRouteLeave',
])

@Component({
	name: 'riskTaskDetail',
	components: {
		PageLayout,
		Info,
		InfoRow,
		riskSection,
	},
})
export default class QueryList extends Vue {
	private addResurveyVisible: boolean = false
	private taskLog: any = []
	private taskLogVisible: boolean = false
	private order: any = ''
	private invoices: any = ''
	private injured: any = ''
	private task: any = {}
	private exporting: boolean = false
	private active: any = 0
	private detail: any = ''
	private riskList: any = []
	private modelInfo: any = ''

	private init() {
		this.detail = ''
		this.riskList = []
		this.modelInfo = ''
		this.$nextTick(() => {
			triggerWindowResizeEvent()
		})
		this.getDetail()
	}

	private get blocks() {
		const detail = this.detail
		const taskInfo = detail.taskInfo || {}
		const injuredInfo = detail.injuredInfo || {}
		const visitingInfo = detail.visitingInfo || {}
		const fosterInfo =
			detail.fosterInfo && detail.fosterInfo.length ? detail.fosterInfo : [{}]
		const diagnoseInfo =
			detail.diagnoseInfo && detail.diagnoseInfo.length
				? detail.diagnoseInfo
				: [{}]
		const caregiversInfo =
			detail.caregiversInfo && detail.caregiversInfo.length
				? detail.caregiversInfo
				: [{}]
		const livingInfo = detail.livingInfo || {}
		const arr = []
		arr.push({
			title: '任务信息',
			children: [
				{ label: '分公司名称', value: taskInfo.subCompanyName },
				{ label: '报案号码', value: taskInfo.registNo },
				{ label: '保单号', value: taskInfo.policyNo },
				{ label: '处理环节', value: taskInfo.node },
				{ label: '被保人姓名', value: taskInfo.insurantName },
				{ label: '报案电话', value: taskInfo.callNo },
				{ label: '伤者姓名', value: taskInfo.name },
				{ label: '伤者电话', value: taskInfo.selfPhone },
				{ label: '标的车牌', value: taskInfo.carNo },
				{ label: '出险地', value: taskInfo.accAddress },
				{ label: '事故类型', value: taskInfo.accidentType },
				{ label: '损失类型', value: taskInfo.lossType },
				{ label: '就诊类型', value: taskInfo.medicalType },
				{ label: '伤者类型', value: taskInfo.injuryType },
				{ label: '事故责任比例', value: taskInfo.accidentRate },
				{ label: '事故发生时间', value: taskInfo.accTime },
			],
		})
		arr.push({
			title: '伤者信息',
			children: [
				{ label: '证件类型', value: injuredInfo.idType },
				{ label: '证件号码', value: injuredInfo.idNo },
				{ label: '姓名', value: injuredInfo.name },
				{ label: '性别', value: injuredInfo.sex },
				{ label: '年龄', value: injuredInfo.injuryAge },
				{ label: '出生日期', value: injuredInfo.birthday },
				{ label: '户籍地', value: injuredInfo.injuryCensusRegisterAddress },
				{ label: '户籍性质', value: injuredInfo.injuryCensusRegisterType },
			],
		})
		arr.push({
			title: '伤者就诊信息',
			children: [
				{ label: '就诊医院', value: visitingInfo.visitingHospital },
				{ label: '就诊科室', value: visitingInfo.visitingDepartment },
				{ label: '床位号', value: visitingInfo.bedNo },
				{ label: '是否在医院', value: visitingInfo.inHospital },
				{ label: '入院日期', value: visitingInfo.hospitalizedDate },
				{ label: '出院日期', value: visitingInfo.leaveDate },
				{ label: '住院天数', value: visitingInfo.hospitalLimit },
				{ label: 'ICD10编码', value: visitingInfo.icd10No },
				{ label: '损伤部位1', value: visitingInfo.injurySite1 },
				{ label: '损伤部位2', value: visitingInfo.injurySite2 },
				{ label: '诊断名称', value: visitingInfo.diagnoseName },
				{ label: '现阶段治疗方案', value: visitingInfo.nowOperationName },
				{ label: '伤情程度', value: visitingInfo.injuryDegree },
				{ label: '治疗方式', value: visitingInfo.treatWays },
				{ label: '死亡时间', value: visitingInfo.deathDate },
				{ label: '死者户籍注销时间', value: visitingInfo.householdCancelTime },
			],
		})
		for (const [index, item] of fosterInfo.entries()) {
			let children = [
				{ label: '抚养人类型', value: item.dependType },
				{ label: '抚养关系', value: item.fosterRelation },
				{ label: '共同抚养人数', value: item.dependCount },
				{ label: '抚养人姓名', value: item.fosterName },
				{ label: '抚养人户籍性质', value: item.fosterCensusRegisterType },
				{ label: '抚养人出生日期', value: item.fosterBirthDate },
				{ label: '抚养人年龄', value: item.fosterAge },
				{ label: '抚养年限', value: item.fosterLimit },
				{ label: '抚养赔偿年度', value: item.fosterCostYear },
				{ label: '抚养赔偿标准采集地', value: item.fosterStdArea },
				{ label: '抚养赔偿标准', value: item.fosterCostStand },
			]
			arr.push({
				title: `抚养人信息${fosterInfo.length > 1 ? index + 1 : ''}`,
				children,
			})
		}
		for (const [index, item] of diagnoseInfo.entries()) {
			let children = [
				{ label: '伤残等级', value: item.disabilityGrade },
				{ label: '伤残系数', value: item.disabilityRate },
				{ label: '评残条款', value: item.disabilityClass },
				{ label: '伤残等级描述', value: item.disabilityGradeDesc },
				{ label: '伤残鉴定类型', value: item.identifyType },
				{ label: '伤残鉴定机构', value: item.identifyName },
				{ label: '鉴定生效日期', value: item.identifyEffectDate },
			]
			arr.push({
				title: `伤残信息${diagnoseInfo.length > 1 ? index + 1 : ''}`,
				children,
			})
		}
		for (const [index, item] of caregiversInfo.entries()) {
			let children = [
				{ label: '护理人身份', value: item.caregiversIdentity },
				{ label: '护理人姓名', value: item.caregiversName },
				{ label: '护理人从事行业', value: item.caregiversIndustry },
				{ label: '护理人收费', value: item.caregiversChargeDay },
				{ label: '护理实际天数', value: item.actNursingLimit },
			]
			arr.push({
				title: `护理人信息${caregiversInfo.length > 1 ? index + 1 : ''}`,
				children,
			})
		}
		arr.push({
			title: '伤者工作地居住地信息',
			children: [
				{ label: '伤者居住地', value: livingInfo.liveDetailAddress },
				{ label: '伤者经常居住地', value: livingInfo.oftenLivePlace },
				{ label: '伤者居住年限', value: livingInfo.liveLimit },
			],
		})
		return arr
	}

	private get fees() {
		const detail = this.detail
		const cost = detail.cost || {}
		return [
			{ label: '医疗费（实际产生）', value: cost.medicalExamCost },
			{ label: '医疗费（后续医疗）', value: cost.treatExamCost },
			{ label: '住院伙食补助费', value: cost.mealExamCost },
			{ label: '误工费', value: cost.delayExamCost },
			{ label: '护理费', value: cost.nursingExamCost },
			{ label: '营养费', value: cost.nutritionExamCost },
			{ label: '残疾赔偿金', value: cost.disabilityExamCost },
			{ label: '残疾辅助器具费', value: cost.disabilityDeviceExamCost },
			{ label: '死亡赔偿金', value: cost.deathExamCost },
			{ label: '丧葬费', value: cost.funeralExamCost },
			{ label: '精神损失慰问金', value: cost.mentalInjuryExamCost },
			{ label: '被抚养人生活费', value: cost.fosterExamCost },
			{ label: '住宿费', value: cost.hotelExamCost },
			{ label: '交通费', value: cost.trafficExamCost },
			{ label: '定损总金额', value: cost.examAmount },
			{ label: '人伤结算金额', value: cost.injuryEndAmount },
		]
	}

	private activated() {
		this.init()
	}

	private beforeRouteUpdate(to: any, from: any, next: any) {
		this.$nextTick(() => {
			this.init()
		})
		next()
	}

	private getDetail() {
		return RiskApi.getDetail(this.$route.params.id).then((res: any) => {
			this.detail = res.data
			this.riskList = this.detail.riskList || []
			this.modelInfo = this.detail.modelInfo

			this.$nextTick(() => {
				triggerWindowResizeEvent()
			})
		})
	}
}
